//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Assessment types.   */
export const AssessmentType = {
    /** The conflict profile assessment types guid */
    Conflict: "CE7E1986-FDC3-4A3F-9464-26A65D684E29",
    /** The DISC assessment types guid */
    Disc: "A5CB2E3D-118A-41F2-972B-325A328B0B54",
    /** The Emotional Intelligence assessment types guid */
    Eq: "DE2D65A3-FC36-4472-B5DF-FAD30EEC27A0",
    /** The Spiritual Gifts assessment types guid */
    Gifts: "B8FBD371-6B32-4BE5-872F-51400D16EC5D",
    /** The Motivators assessment types guid */
    Motivators: "EABE1ABA-4A23-44FF-8C7F-6B71383BED09",
};
